import axios from "axios"

const instanceCommon = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

export default instanceCommon
